import axios from '../../../utils/AxiosUtils';
import i18n from '../../../i18next';

import {
    LOADING, LOAD_ORDER_DETAILS_SUCCESS, CLEAR_ORDER_DETAILS, LOAD_REFUND_HISTORY_SUCCESS
} from '../../types';
import MessageUtils from "../../../utils/MessageUtils";
import { doLoadOrdersHistory } from "./OrdersHistoryAction";
import { push } from "connected-react-router";


export const getOrdersDetails = (orderId, callback, restaurantId, puToOrderHistory, state) => {
    return (dispatch) => {

        const url = `/order/${orderId}`;

        axios().get(url)
            .then(response => getOrdersDetailsSuccess(dispatch, response, callback, restaurantId, puToOrderHistory, state))
            .catch(error => console.log('error ', error));
        // .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:orderDetailsActions.loadOrderDetailsFailure')));
    }
}


const getOrdersDetailsSuccess = (dispatch, response, callback, restaurantId, puToOrderHistory, state) => {
    dispatch({ type: LOAD_ORDER_DETAILS_SUCCESS, payload: response.data });
    if (callback) {
        callback();
    }

    if (puToOrderHistory) {
        dispatch(push(`/restaurant/${restaurantId}/orders?orderDetailsOpen=${state.orderDetailsScreenOpened}`));
    }
}


export const refund = (data, orderId, restaurantId, currentPageNumber, callback, calledFromOrdersLink) => {
    return (dispatch, getState) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/payment/${orderId}/refund`;

        axios().post(url, data)
            .then(response => refundSuccess(dispatch, response, restaurantId, currentPageNumber, getState, callback, calledFromOrdersLink))
            .catch(error => {
                console.log('ERROR ', error.response.data);MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:orderDetailsActions.refundFailure'))});
    }
}
const refundSuccess = (dispatch, response, restaurantId, currentPageNumber, getState, callback, calledFromOrdersLink) => {
    dispatch({ type: LOADING, payload: false });
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:orderDetailsActions.refundSucceed'));
    if (calledFromOrdersLink !== 'ordersLink') {
        doLoadOrdersHistory(restaurantId, currentPageNumber, undefined, dispatch, getState);
    }

    callback();
}

export const refundGiftCard = (data, orderId, restaurantId, currentPageNumber, callback, calledFromOrdersLink) => {
    return (dispatch, getState) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/gift-card-provider/${orderId}/refund`;

        axios().post(url, data)
            .then(response => refundGiftCardSuccess(dispatch, response, restaurantId, currentPageNumber, getState, callback, calledFromOrdersLink))
            .catch(error => {
                console.log('ERROR ', error.response.data);MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:orderDetailsActions.refundFailure'))});
    }
}

const refundGiftCardSuccess = (dispatch, response, restaurantId, currentPageNumber, getState, callback, calledFromOrdersLink) => {
    dispatch({ type: LOADING, payload: false });
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:orderDetailsActions.refundSucceed'));
    if (calledFromOrdersLink !== 'ordersLink') {
        doLoadOrdersHistory(restaurantId, currentPageNumber, undefined, dispatch, getState);
    }

    callback();
}

export const cancelOrder = (cancelReason, orderId, restaurantId, currentPageNumber, callback) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/order/${orderId}/cancel?reason=${cancelReason}`;

        axios().put(url, {})
            .then(response => cancelOrderSuccess(dispatch, response, restaurantId, currentPageNumber, getState, callback))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:orderDetailsActions.cancelOrderFailure')));
    }
}


const cancelOrderSuccess = (dispatch, response, restaurantId, currentPageNumber, getState, callback) => {
    dispatch({ type: LOADING, payload: false });
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:orderDetailsActions.cancelOrderSucceed'));

    if (restaurantId) {
        doLoadOrdersHistory(restaurantId, currentPageNumber, undefined, dispatch, getState);
    }

    callback();
}


export const getRefundHistory = (orderId) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/order/${orderId}/refunds`;

        axios().get(url)
            .then(response => getRefundHistorySuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:orderDetailsActions.getRefundHistoryFailure')));
    }
}

const getRefundHistorySuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_REFUND_HISTORY_SUCCESS, payload: response.data });
}


export const clearSelectedOrder = () => {
    return (dispatch) => {
        dispatch({ type: CLEAR_ORDER_DETAILS });
    }
}

export const resendFailedOrder = (orderId, updateOrderStatus) => {
    return (dispatch) => {

        const url = `/order/${orderId}/resend`;

        axios().put(url, {})
            .then(response => resendFailedOrderSuccess(dispatch, response, updateOrderStatus))
            .catch(error => {
                MessageUtils.errorMessageResponse(
                    dispatch,
                    error.response.data,
                    i18n.t('actions:orderDetailsActions.resetOrderFailure')
                );
                if (updateOrderStatus) updateOrderStatus();
            });
    }
};

const resendFailedOrderSuccess = (dispatch, response, updateOrderStatus) => {
    if (updateOrderStatus) updateOrderStatus(response.data.status);
};

export const manuallyAcceptOrder = (orderId, callback) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/order/${orderId}/manual-accept`;

        axios().post(url, {})
            .then(response => {
                dispatch({ type: LOADING, payload: false });
                callback();
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));
            })
            .catch(error => {
                callback();
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure'));
            })
    }
}

export const addExtraTime = (orderId, minutes) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/order/${orderId}/accept?extraTime=${minutes}`;

        axios().put(url, {})
            .then(response => {
                dispatch({ type: LOADING, payload: false });
                dispatch({ type: LOAD_ORDER_DETAILS_SUCCESS, payload: response.data });
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.addExtraTimeSuccess'));
            })
            .catch(error => {
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.addExtraTimeFailure'));
            })
    }
}

export const getOrderAsPdf = (orderId) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/order/${orderId}/to-pdf`;

        axios().get(url, { responseType: 'blob' })
            .then(response => {
                dispatch({ type: LOADING, payload: false });
                let blob = new Blob([response.data], { type: 'application/pdf' });
                let pdfURL = window.URL.createObjectURL(blob);
                window.open(pdfURL, '_blank');
            })
            .catch(error => {
                dispatch({ type: LOADING, payload: false });
                console.log('ERROR', error)
            })
    }
}

export const downloadPosOrderData = (orderId) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/order/${orderId}/download-posOrder`;

        axios().get(url, { responseType: 'blob' })
            .then(response => {
                dispatch({ type: LOADING, payload: false });
                let blob = new Blob([response.data], { type: 'text/plain;charset=utf-8' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `POS-Order-Data-OrderId-${orderId}.txt`;
                link.click();
            })
            .catch(error => {
                dispatch({ type: LOADING, payload: false });
                console.log('ERROR', error)
            })
    }
}


// WEBPACK FOOTER //
// ./src/actions/restaurants/orders/OrderDetailsActions.js